import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SettingsIcon from '@mui/icons-material/Settings';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useAuthorization } from 'contexts/AuthContextProvider.jsx';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { useTranslation } from "react-i18next";
import "../../css/components/Sidebar/SidebarExtraButtons.css";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import NewUpdatesModal from '../Custom/NewUpdatesModal';

const MoreButtonList = ({ handleNavigateToProfile, handleNavigateToSupport, workspaceId }) => {
  const { logout } = useAuthorization();
  const { t } = useTranslation();

  const [isUpdatesModalOpen, setUpdatesModalOpen] = useState(false);

  const handleToggleUpdatesModal = () => {
    setUpdatesModalOpen((prev) => !prev);
  };

  return (
    <>
    <List>
      <ListItemButton component={Link} to={`${workspaceId}/calendar/overview`}>
        <ListItemIcon>
          <CalendarTodayIcon className="extra-buttons-text-color" />
        </ListItemIcon>
        <ListItemText primary={t("calendar.calendar")} />
      </ListItemButton>

      <ListItemButton component={Link} to="notifications">
        <ListItemIcon>
          <CircleNotificationsIcon className="extra-buttons-text-color" />
        </ListItemIcon>
        <ListItemText primary={t("notifications.notifications")} />
      </ListItemButton>

      {workspaceId && (
        <ListItemButton component={Link} to={`${workspaceId}/statistics`}>
          <ListItemIcon>
            <QueryStatsIcon className="extra-buttons-text-color" />
          </ListItemIcon>
          <ListItemText primary={t("sidebar.stats")} />
        </ListItemButton>
      )}

      <ListItemButton component={Link} onClick={handleNavigateToProfile}>
        <ListItemIcon>
          <AccountBoxIcon className="extra-buttons-text-color" />
        </ListItemIcon>
        <ListItemText primary={t("sidebar.profile")} />
      </ListItemButton>

      <ListItemButton component={Link} to={`${workspaceId}/settings`}>
        <ListItemIcon>
          <SettingsIcon className="extra-buttons-text-color" />
        </ListItemIcon>
        <ListItemText primary={t("sidebar.settings")} />
      </ListItemButton>
      

      <ListItemButton component={Link} onClick={handleNavigateToSupport}>
        <ListItemIcon>
          <SupportAgentIcon className="extra-buttons-text-color" />
        </ListItemIcon>
        <ListItemText primary={t("sidebar.support")} />
      </ListItemButton>

      <ListItemButton onClick={handleToggleUpdatesModal}>
        <ListItemIcon>
          <TipsAndUpdatesIcon className="extra-buttons-text-color" />
        </ListItemIcon>
        <ListItemText primary={t("sidebar.new_updates")} />
      </ListItemButton>

      <ListItemButton component={Link} onClick={() => { logout(); }}>
        <ListItemIcon>
          <ExitToAppIcon className="extra-buttons-text-color" />
        </ListItemIcon>
        <ListItemText primary={t("sidebar.logout")} />
      </ListItemButton>

      <NewUpdatesModal isOpen={isUpdatesModalOpen} setIsOpen={setUpdatesModalOpen} />
    </List>
    <Typography sx={{display: "flex", flexGrow: 1, alignItems: "flex-end", justifyContent: "center", mr: 1, mb:1}}>
      Atlantic Infinity ® 2025
    </Typography>
    </>
    


  );
};

export default MoreButtonList;